export default {
  milk2: '0xD6a14c501e2725f76c3464fF58EA6dCB880c4778',
  shake: '0xDE6A9B5806CC3FB26C9e333A0e1d8Cac7F4067F9',
  shadowBridge: '0x19749FE9286292dec25803178C49A1B582aC93a6',
};
